import { render, staticRenderFns } from "./KkdayProductManagement.vue?vue&type=template&id=71b7f306&scoped=true"
import script from "./KkdayProductManagement.vue?vue&type=script&lang=js"
export * from "./KkdayProductManagement.vue?vue&type=script&lang=js"
import style0 from "./KkdayProductManagement.vue?vue&type=style&index=0&id=71b7f306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b7f306",
  null
  
)

export default component.exports